@if (label) {
  <app-control-header
    [label]="label"
    [required]="required"
    [labelWithColon]="labelWithColon"
  ></app-control-header>
}

<div class="grid grid-cols-2 gap-2" (blur)="markAsDirty()">
  <app-date-picker
    #fromDate
    [validateOnDirty]="validateOnDirty"
    [required]="required"
    [placeholder]="fromDatePlaceholder"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [isDisabled]="isDisabled"
    (dateChanged)="dateChanged()"
  ></app-date-picker>

  <app-date-picker
    #untilDate
    [validateOnDirty]="validateOnDirty"
    [placeholder]="untilDatePlaceholder"
    [required]="required"
    [isDisabled]="!fromDateDatePicker?.value || isDisabled"
    [minDate]="fromDateDatePicker?.value"
    [maxDate]="maxDateLimit"
    (dateChanged)="dateChanged()"
  ></app-date-picker>
</div>
